const CITY_GETTERS = {
  getCities: state => state.cities,
  getError: state => state.status.error,
};

export default CITY_GETTERS;
